// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".field_placeholder[data-v-6a5e9bc3]{color:var(--el-text-color-placeholder);font-size:12px}", ""]);
// Exports
module.exports = exports;
